export const bannerMeta = {
  "dragon-ball-banner": {
    name: "Dragon Ball",
    image: "/images/banners/dragon-ball-banner.jpg",
    animation: "/images/animations/db-summon.gif",
    sound: "/sounds/dragonball-summon.mp3",
    raritySounds: {
      "4": "/sounds/dragonball-rarity-4.mp3",
      "5": "/sounds/dragonball-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-yellow-800 via-red-900 to-black"
  },

  "jujutsu-kaisen-demon-slayer-banner": {
    name: "JJK × Demon Slayer",
    image: "/images/banners/jjk-banner.jpg",
    animation: "/images/animations/jjk-summon.gif",
    sound: "/sounds/jjk-summon.mp3",
    raritySounds: {
      "4": "/sounds/jjk-rarity-4.mp3",
      "5": "/sounds/jjk-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-purple-900 via-black to-red-900"
  },

  "naruto-banner": {
    name: "Naruto",
    image: "/images/banners/naruto-banner.jpg",
    animation: "/images/animations/naruto-summon.gif",
    sound: "/sounds/naruto-summon.mp3",
    raritySounds: {
      "4": "/sounds/naruto-rarity-4.mp3",
      "5": "/sounds/naruto-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-orange-800 via-black to-red-800"
  },

  "one-piece-banner": {
    name: "One Piece",
    image: "/images/banners/one-piece-banner.jpg",
    animation: "/images/animations/one-piece-summon.gif",
    sound: "/sounds/onepiece-summon.mp3",
    raritySounds: {
      "4": "/sounds/onepiece-rarity-4.mp3",
      "5": "/sounds/onepiece-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-blue-900 via-black to-red-700"
  },

  "one-punch-man-my-hero-academia-banner": {
    name: "OPM × MHA",
    image: "/images/banners/opm-mha-banner.jpg",
    animation: "/images/animations/opm-mha-summon.gif",
    sound: "/sounds/opm-mha-summon.mp3",
    raritySounds: {
      "4": "/sounds/opm-mha-rarity-4.mp3",
      "5": "/sounds/opm-mha-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-gray-900 via-black to-yellow-800"
  },


  "dragon-ball-one-piece-banner": {
    name: "Dragon Ball × One Piece",
    image: "/images/banners/db-op-banner.jpg",
    animation: "/images/animations/db-op-summon.gif",
    sound: "/sounds/db-op-summon.mp3",
    raritySounds: {
      "4": "/sounds/db-op-rarity-4.mp3",
      "5": "/sounds/db-op-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-red-900 via-black to-blue-900"
  },

  "All-characters-mystery-banner": {
    name: "All Characters",
    image: "/images/banners/all-banner.jpg",
    animation: "/images/animations/all-summon.gif",
    sound: "/sounds/all-summon.mp3",
    raritySounds: {
      "4": "/sounds/all-rarity-4.mp3",
      "5": "/sounds/all-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-gray-800 via-black to-red-800"
  },
  "Premium-banner": {
    name: "Premium-banner",
    image: "/images/banners/all-banner.jpg",
    animation: "/images/animations/all-summon.gif",
    sound: "/sounds/all-summon.mp3",
    raritySounds: {
      "4": "/sounds/all-rarity-4.mp3",
      "5": "/sounds/all-rarity-5.mp3",
      "6": "/sounds/all-rarity-5.mp3"
    },
    gradient: "bg-gradient-to-r from-gray-300 via-gray-100 to-amber-500"
  }
};
